export function sizing(factor: number) {
  return factor * 8;
}

export function spacing(...args: (string | number)[]) {
  return args
    .map((arg) => (typeof arg === "string" ? arg : `${sizing(arg)}px`))
    .join(" ");
}
